import { render, staticRenderFns } from "./supervisor-report.vue?vue&type=template&id=be96f296"
import script from "./supervisor-report.vue?vue&type=script&lang=js"
export * from "./supervisor-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports